import { render, staticRenderFns } from "./LinkPicker.vue?vue&type=template&id=2ce8047f&scoped=true&lang=pug&"
import script from "./LinkPicker.vue?vue&type=script&lang=js&"
export * from "./LinkPicker.vue?vue&type=script&lang=js&"
import style0 from "./LinkPicker.vue?vue&type=style&index=0&id=2ce8047f&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ce8047f",
  null
  
)

/* custom blocks */
import block0 from "./LinkPicker.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports